import React from "react";

import {user_border} from "../../../assets/images/fluster";
import {user_image} from "../../../assets/images/fluster";

const FluserUser = ({
  display_name = "Somay Chauhan",
  profile_image = "https://gameapart-assets.s3.amazonaws.com/photos%2F1617184637254_437914EE-24C8-452D-8F75-4C7704F9CC9C.jpg",
}) => {
  return (
    <>
      <h4 className="user-name">{display_name}</h4>
      <div className="user-image-container">
        <img src={user_border} alt="" className="user-border" />
        <img src={profile_image} alt="" className="user-image" />
      </div>
    </>
  );
};

export default FluserUser;
